module.exports = __webpack_public_path__ + "img/BackgroundGCE.e34bcd87.png";